import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { v4 as uuidv4 } from "uuid";

export class TerminateNodeModel extends DefaultNodeModel {
  constructor({
    id = `TerminateNode_${uuidv4()}`,
    color = "rgb(192,0,0)",
    position = { x: 100, y: 100 },
    nodeProperties = { Name: "Terminate", Type: "Event" },
  }) {
    super({
      id: id,
      name: nodeProperties.Name,
      color: color,
      extras: { properties: nodeProperties },
    });
    this.setPosition(position.x, position.y);
    this.addInPort("Event");
  }
}
